'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
import moment from "moment";
var ngModule = getNgModule(__filename);
ngModule.controller('DocumentsEcheanceEditionController', function ($scope, $translate, $q, $http, UUID, $modal, $notifications, arrayUtils, $dialogBox, tlTableUtils, lovService) {
  $q.when(lovService.getTypesDocuments()).then(function (typesDocument) {
    $scope.typesDocument = typesDocument;
  });
  var documentType = function documentType(doc) {
    if (doc.type === 'CONTRAT_INITIAL') {
      return 1;
    }
    if (doc.type === 'AVENANT') {
      return 2;
    }
    if (doc.type === 'ECHEANCIER') {
      return 3;
    }
    if (doc.type === 'AUTRE_DOCUMENT') {
      return 4;
    }
    if (doc.type === 'AVIS_ECHEANCE') {
      return 5;
    }
    return 9;
  };
  var sortDocuments = function sortDocuments(documents) {
    documents.sort(function (doc1, doc2) {
      var byType = documentType(doc1) - documentType(doc2);
      if (byType === 0) {
        return doc2.dateAjout - doc1.dateAjout; // Date plus récente first
      }
      return byType;
    });
  };
  var updateNbDocsEcheance = function updateNbDocsEcheance() {
    $scope.echeance.nbDocsEcheance = $scope.echeanceDocuments.length;
  };
  $scope.produitDocuments;
  $scope.echeanceDocuments;
  var rebuildTablesDocuments = function rebuildTablesDocuments() {
    if ($scope.allDocuments) {
      $scope.produitDocuments = _.filter($scope.allDocuments.documents, function (d) {
        return d.dateEcheance === null;
      });
      $scope.echeanceDocuments = _.filter($scope.allDocuments.documents, function (d) {
        return d.dateEcheance != null;
      });
    }
  };
  $scope.deleteDocument = function (model) {
    $dialogBox.confirm({
      title: "Supprimer le document '" + model.nom + "'",
      text: "Etes-vous sûr de vouloir supprimer ce document ?"
    }).then(function () {
      $http.post('/rest/documents/delete/', model.id).then(function () {
        $notifications.info("Suppression effectuée.");
        var index = _.findIndex($scope.allDocuments.documents, function (ligne) {
          return ligne.id === model.id;
        });
        arrayUtils.deleteElement($scope.allDocuments.documents, index);
        if ($scope.selectedDocument && $scope.selectedDocument.id === model.id) {
          $scope.selectedDocument = null;
        }
        rebuildTablesDocuments();
        updateNbDocsEcheance();
        updateTables();
      });
    });
  };
  $scope.toggleJustificatifTresorerie = function (model) {
    $http.post('/rest/produitDocuments/tagTresorerie/', {
      documentId: model.id,
      justificatifTresorerie: model.justificatifTresorerie
    }).then(function () {
      $notifications.info("Mise à jour enregistrée.");
    });
  };
  $scope.allDocuments;
  var updateAllDocuments = function updateAllDocuments() {
    var data = {
      produitId: $scope.produitId,
      dateEcheance: $scope.echeance.dateFin
    };
    $http.post('/rest/produitDocuments', data).then(function (response) {
      $scope.allDocuments = response.data;
      sortDocuments($scope.allDocuments.documents);
      rebuildTablesDocuments();
      updateNbDocsEcheance();
      if ($scope.echeanceDocuments && $scope.echeanceDocuments.length > 0) {
        $scope.selectedDocument = $scope.echeanceDocuments[0];
      }
    });
  };
  updateAllDocuments();
  $scope.uploadOptions = {
    url: '/rest/documents/upload',
    dropZone: '.se-details-echeances',
    formData: {
      parentNodeId: $scope.produitId
    }
  };
  var editionPopinOptions = {
    controller: "DocumentEcheanceEditionPopinController",
    template: require("./documentEcheanceEditionPopin.html"),
    options: {
      width: 600
    }
  };
  var openEditionPopin = function openEditionPopin(document, initial, allowedContent) {
    return $modal.open(_.extend(editionPopinOptions, {
      scope: $scope,
      vars: {
        document: document,
        initial: initial,
        allowedTypes: _.filter($scope.typesDocument, function (e) {
          return _.includes(allowedContent, e.id);
        }),
        dateEcheance: $scope.echeance.dateFin
      }
    }));
  };
  $scope.beforeDocumentUpload = function (uploadOptions, addedFile) {
    var document = {
      label: addedFile.name || $translate('documents.NouveauDocument'),
      tags: {
        JUSTIFICATIF_TRESORERIE: true
      }
    };
    return openEditionPopin(document, true, $scope.allDocuments.allowedDocsTypes).then(function (documentInfos) {
      return _objectSpread({}, uploadOptions.formData, {}, documentInfos, {}, documentInfos.tags);
    });
  };
  $scope.onDocumentUpload = function (result) {
    var document = {
      id: result.documentId,
      fileId: result.fileId,
      nom: result.fileName,
      type: result.type,
      dateAjout: moment(),
      justificatifTresorerie: result.tags['JUSTIFICATIF_TRESORERIE'],
      dateEcheance: result.tags['DATE_ECHEANCE']
    };
    $scope.allDocuments.documents.push(document);
    sortDocuments($scope.allDocuments.documents);
    rebuildTablesDocuments();
    updateNbDocsEcheance();
    $scope.selectedDocument = _.find($scope.echeanceDocuments, function (e) {
      return function () {
        return e.id === document.id;
      };
    });
    updateTables();
  };
  $scope.createDocumentExterne = function () {
    var document = {
      id: UUID(),
      label: "",
      url: "",
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      size: 0,
      sizeRec: 0,
      externe: true,
      tags: {
        JUSTIFICATIF_TRESORERIE: true
      },
      dateAjout: moment()
    };
    openEditionPopin(document, true, $scope.allDocuments.allowedDocsTypes).then(function () {
      $http.post('/rest/documents/add', document, {
        params: {
          parentNodeId: $scope.produitId
        }
      }).then(function () {
        document.justificatifTresorerie = document.tags && document.tags['JUSTIFICATIF_TRESORERIE'];
        document.dateEcheance = document.tags && document.tags['DATE_ECHEANCE'];
        document.nom = document.label;
        $scope.allDocuments.documents.push(document);
        sortDocuments($scope.allDocuments.documents);
        rebuildTablesDocuments();
        updateNbDocsEcheance();
        $scope.selectedDocument = _.find($scope.echeanceDocuments, function (e) {
          return function () {
            return e.id === document.id;
          };
        });
        updateTables();
      });
    });
  };
  var echeanceDocumentsTableColumns = [{
    title: 'Nom',
    attribute: 'nom',
    template: '{{model.nom | ellipsis:50}}'
  }, {
    title: 'Type',
    attribute: 'type',
    width: "230px",
    template: "<span>{{'lov.typesDocuments.'+model.type | translate}}</span>"
  }, {
    title: 'Date d\'ajout',
    attribute: 'dateAjout',
    width: "85px",
    template: '<span tl-tooltip="{{model.dateAjout | dateLong}}">{{model.dateAjout | dateShort}}</span>'
  }, {
    title: 'Justificatif trésorerie',
    attribute: 'justificatifTresorerie',
    width: "95px",
    cellClass: 'align-c',
    template: '' + '<i authz-if-role="!SAISIE" class="fa fa-check fa-2x green" ng-show="model.justificatifTresorerie"></i>' + '<i authz-if-role="!SAISIE" class="fa fa-times fa-2x grey" ng-show="!model.justificatifTresorerie"></i>' + '<label authz-if-role="SAISIE" class="toggle-btn">\n' + '  <tl-checkbox ng-click="toggleJustificatifTresorerie(model)" ng-model="model.justificatifTresorerie"></tl-checkbox>\n' + '</label>\n'
  }, {
    title: "",
    width: "95px",
    cellClass: 'align-c',
    template: '<tl-icon-button authz-if-role="SAISIE" class="" icon="delete" title="Supprimer le document" ng-click="deleteDocument(model); $event.stopPropagation();"></tl-icon-button>'
  }];
  $scope.echeanceDocumentsTable;
  var updateTables = function updateTables() {
    $scope.echeanceDocumentsTable = {
      source: "echeanceDocuments",
      id: "echeanceDocumentsTable",
      height: '500',
      allowSelection: true,
      selectionAttribute: "selectedDocument",
      selectionScope: $scope,
      columns: echeanceDocumentsTableColumns
    };
  };
  updateTables();
  tlTableUtils.fixResize($scope, 'echeanceDocuments');
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/documentsEcheanceEdition.js
// module id = 2775
// module chunks = 13